import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { videoService } from '../../services/api';

// Actions asynchrones
export const fetchActiveVideos = createAsyncThunk(
  'videos/fetchActive',
  async (_, { rejectWithValue }) => {
    try {
      const response = await videoService.getActiveVideos();
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const fetchVideosByProfilAndAge = createAsyncThunk(
  'videos/fetchByProfilAndAge',
  async ({ profilTypeId, agesSectionId }, { rejectWithValue }) => {
    try {
      const response = await videoService.getVideosByProfilAndAge(profilTypeId, agesSectionId);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const fetchVideoById = createAsyncThunk(
  'videos/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await videoService.getVideoById(id);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// État initial
const initialState = {
  videos: [],
  currentVideo: null,
  loading: false,
  error: null,
  lastFetch: null
};

// Slice
const videoSlice = createSlice({
  name: 'videos',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearVideos: (state) => {
      state.videos = [];
    },
    clearCurrentVideo: (state) => {
      state.currentVideo = null;
    }
  },
  extraReducers: (builder) => {
    // Fetch active videos
    builder
      .addCase(fetchActiveVideos.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchActiveVideos.fulfilled, (state, action) => {
        state.loading = false;
        state.videos = action.payload;
        state.lastFetch = Date.now();
      })
      .addCase(fetchActiveVideos.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Fetch videos by profil and age
    builder
      .addCase(fetchVideosByProfilAndAge.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVideosByProfilAndAge.fulfilled, (state, action) => {
        state.loading = false;
        console.log('📹 Vidéos reçues de l\'API:', action.payload);
        console.log('📹 Nombre de vidéos:', action.payload?.length || 0);
        state.videos = action.payload;
        state.lastFetch = Date.now();
      })
      .addCase(fetchVideosByProfilAndAge.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // Fetch video by ID
    builder
      .addCase(fetchVideoById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVideoById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentVideo = action.payload;
      })
      .addCase(fetchVideoById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

// Actions
export const { clearError, clearVideos, clearCurrentVideo } = videoSlice.actions;

// Sélecteurs
export const selectVideos = (state) => state.videos.videos;
export const selectCurrentVideo = (state) => state.videos.currentVideo;
export const selectVideosLoading = (state) => state.videos.loading;
export const selectVideosError = (state) => state.videos.error;

// Reducer
export default videoSlice.reducer;
